<div class="blur-content">
    <div class="page-container" style="background-color: #f2f8fa !important">
        <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
        <div class="main-content">
            <app-header></app-header>
            <div class="main-content-inner">
              <div class="chat-container">
                  <ng-container *ngIf="displayLoader">
                      <div class="loader-container" style="width: 95%">
                        <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]">
                          <li class="t_loader">
                            <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
                          </li>
                        </ng-container>
                      </div>
                    </ng-container>
                    <!-- Chat Content Area -->
                    <div *ngIf="!displayLoader" class="chat-content" style="height: 100px; overflow-y: auto; margin-bottom: 20px;">
                        <p style="color: white; font-size: 18px; font-weight: bolder;">When writing instructions for AI, please be clear, specific, and aligned with your data structure. Include field names, expected values (e.g., 'True', 'Yes', 'M', etc.), and any necessary context to guide accurate SQL generation. </p>
                    </div>

                    <!-- Input Area -->
                    <div *ngIf="!displayLoader" class="input-container" style="position: relative; clear: both; margin-top: 15px;">
                        <div class="input-wrapper">
                            <textarea type="text" placeholder="Add Instructions for Ai-Search!" [(ngModel)]="adminInstructions"  
                                class="form-control custom-input" (keyup.enter)="submitInstructions()" [disabled]="loading"
                                style="border-color: white; min-height: 400px;">
                             </textarea>
                            <div class="input-actions">
                                <button class="send-button" (click)="submitInstructions()" [title]="loading ? 'Submitting' : 'Submit'" [disabled]="loading">
                                    <ng-container *ngIf="loading">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-repeat spinning" viewBox="0 0 16 16">
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                                        <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                                    </svg>
                                    </ng-container>
                                    <ng-container *ngIf="!loading">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-arrow-up-short" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5" />
                                        </svg>
                                    </ng-container>
                                </button>
                                
                            </div>
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>